export const PageLayout = (props) => {
    return (
        <>
            {props.children}
        </>
    );
}